import { render } from "./AgregarPedidos.vue?vue&type=template&id=f83b840c"
import script from "./AgregarPedidos.vue?vue&type=script&lang=js"
export * from "./AgregarPedidos.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__